import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { defaultApiResponseHandler } from '~/util';

export enum FormTypeEnum {
    SEND_REFERRAL = 1,
}

export enum FieldTypeEnum {
    TEXT = 1,
    NUMBER = 2,
    DATE = 3,
    INTEGER = 4,
}

export interface OrgFormFieldMetadataType {
    constraints?: {
        greater_than_or_equal_to?: null | string | number;
    };
    dropdown_options?: string[];
}

interface FormFieldBaseType {
    id: number;
    name: string;
    description: string;
    field_type: FieldTypeEnum;
    form_type: FormTypeEnum;
    slug: string;
}

export interface OrgFormFieldType {
    id: number;
    visible: boolean;
    required: boolean;
    default_value: null | string | number;
    display_settings: {
        referral_sender_selects_hub_organization: boolean;
    };
    metadata: OrgFormFieldMetadataType;
    form_field: FormFieldBaseType;
}

export type GetReferralFieldSettingsReturnType = {
    data: {
        organization_form_fields: Array<OrgFormFieldType>;
    };
};

export const useGetReferralFieldSettings = () => {
    const services = React.useContext(ServicesContext);

    const getReferralFieldSettings = useCallback(async () => {
        try {
            const result: GetReferralFieldSettingsReturnType = await services.api.call(
                {
                    method: 'get',
                    url: '/core-api/send-referral-form-fields',
                },
                { handledErrors: true }
            );
            return result.data.organization_form_fields;
        } catch (error) {
            throw defaultApiResponseHandler(error);
        }
    }, [services.api]);

    return getReferralFieldSettings;
};
